import { render, staticRenderFns } from "./verifications.vue?vue&type=template&id=45f2d2fb&scoped=true"
import script from "./verifications.vue?vue&type=script&lang=js"
export * from "./verifications.vue?vue&type=script&lang=js"
import style0 from "./verifications.vue?vue&type=style&index=0&id=45f2d2fb&prod&scoped=true&lang=css"
import style1 from "@/styles/people-workspace.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../../../2026-08-26/github-cli-gh-codex/work/jiangkv3/web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f2d2fb",
  null
  
)

export default component.exports